
import getters from './getters';
import mutations from './mutations';

const state = {
  loading: false,
  loadingMessage: 'please wait...',
  status: '',
  message: '',
  errorCode: '',
};

const actions = {
  resetMessage({ commit }) {
    const resetState = Object.assign({}, {
      loading: false,
      loadingMessage: 'please wait...',
      status: '',
      message: '',
      errorCode: '',
    });
    commit('SET_STATUS', resetState);
  },
  setLoadingWithMessage({ commit }, message) {
    commit('TOGGLE_LOADING_WITH_MESSAGE', { toggle: true, message });
  },
  setLoadingMessage({ commit }, message) {
    commit('SET_LOADING_MESSAGE', message);
  },
  setLoading({ commit }) {
    commit('TOGGLE_LOADING_WITH_MESSAGE', { toggle: true, message: 'please wait...' });
  },
  unsetLoading({ commit }) {
    commit('TOGGLE_LOADING_WITH_MESSAGE', { toggle: false, message: 'please wait...' });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/stores/Notification/index.js